import { computed } from 'vue'

import i18n from '@/libs/i18n'

const { t } = i18n.global

export const PredefinedText = computed(() => {
    return {
        ErrorLoadData: t('errors.load_data'),
        ErrorOnAdd: t('errors.on_add'),
        ErrorOnEdit: t('errors.on_edit'),
        ErrorOnDelete: t('errors.on_delete'),
        ErrorOnSort: t('errors.on_sort'),
        ErrorOnUploadFile: t('errors.on_upload_file'),
        AddSuccess: t('success.on_add'),
        EditSuccess: t('success.on_edit'),
        DeleteSuccess: t('success.on_delete'),
        SortSuccess: t('success.on_sort'),
        DeleteRow: t('confirmations.delete_row')
    }
})

export enum Theme {
    Light = 'light',
    Dark = 'dark',
    Auto = 'auto'
}

export enum FilterTypes {
    Text = 1,
    Number,
    Date,
    Select,
    MultiSelect,
    Boolean
}

export enum BasicOverviewType {
    Custom = 1,
    Text,
    Boolean,
    Date,
    TextWithColor,
    Tags,
    Sensitive,
    Html
}
